import { CommandBar, Button, Icon, Dropdown, Menu, MenuItem } from '../../workflows/WorkflowsScope';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../root-redux/RootState';
import { setWorkflowSummaryStatus } from '../../workflows/workflows-redux/Workflows.redux';
import { postWorkflow, postWorkflowReleaseManagement } from '../../../services/PostWorkflow.api';
import { addConnection, patchReleaseWorkflow, setReleaseWorkflowStatus } from '../ReleaseData.redux';
import { useEffect, useState } from 'react';
import { addRelease, setReleaseStatus } from '../Releases.redux';
import { ConnectionsCollection } from '../../../model/connections/ConnectionsCollection.model';
import { propagateConnectionReleaseManagement } from '../../../services/PropagateConnections.api';
import { Environment, Release } from '../../../model/releases/Release.model';
import { v4 as uuidv4 } from 'uuid';
import { postRelease, postReleaseReleaseManagement } from '../../../services/PostRelease.api';
import { publishWorkflow, publishWorkflowReleaseManagement } from '../../../services/PublishWorkflow.api';
import { unwrapResult } from '@reduxjs/toolkit';
import { prodReleasePermissionsSelector } from '../ReleaseRBAC.selectors.redux';
import { SuccessNotification } from '../../notifications/SuccessNotification';
import { ErrorNotification } from '../../notifications/ErrorNotification';
import { postInsightFamily, postInsightFamilyReleaseManagement } from '../../../services/PostInsightFamily.api';
import { withErrorBoundary } from '../../../shared-components/ErrorBoundary';
import { ModelMapping } from '../../../model/configModels/ModelMapping.model';
import { getModelMapping_uat } from '../../../services/GetModelMapping.api';
import { updateModelMapping_prod } from '../../../services/PostModelMapping.api';
import { TypeMappingObject } from '../../../model/configModels/TypeMappingObject.model';
import { updateTypeMapping_prod } from '../../../services/PostTypeMapping.api';
import { Schedule } from '../../../model/workflows/Schedule.model';
import { validateInsightFamily_prod } from '../../../services/ValidateInsightFamily.api';
import { EdmEntityTypeSettings } from '../../../model/apiConfig/EdmEntityTypeSettings.model';
import { getApiConfig_uat } from '../../../services/APIConfig/GetApiConig.api';
import { propagateRoute } from '../../../services/APIConfig/PropagateApiConfig.api';
import { MergeRule } from '../../../model/merge-rules/MergeRule.model';
import { getMergeRules_uat } from '../../../services/get-merge-rules/GetMergeRules.api';
import { propagateMergeRule_prod } from '../../../services/get-merge-rules/PropagateMergerule.api';
import { getCatalogueConfig_uat } from '../../../services/GetCatalogueConfig.api';
import { updateCatalogueConfig_prod } from '../../../services/PostCatalogueConfig.api';


export const handlePostRelease = (props:any) => {

  const environments: Environment[] = [
    { environment: "dev", isDeployed: false },
    { environment: "uat", isDeployed: false },
    { environment: "prod", isDeployed: true },
  ];

  const releaseData: Release = {
    environments: environments,
    timestamp: "",
    releaseId: props.releaseId,
    workflowId: props.workflowId,
    version: props.version,
    id: uuidv4().toString(),
    type: "Propagate",
    status: "Published",
    scheduleCreated: false
  };
  
  return releaseData;
};

export const handlePropagateConnections = (props:any) => {
  //IMPORTANT -> Here dev means lower environment and uat means higher environment!!
  const devConnections = props.devConnections;
  const uatConnections = props.uatConnections;
  const devWorkflow = props.devWorkflow;
  let connData : {type: string, id:string}[] = [];

  let dataIngestion = devWorkflow.dataIngestion;
  dataIngestion?.map((item: any) => {
    if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
      connData.push({
        type: item.type,
        id: item.connectionId,
      });
    }
  });

  let delta = devWorkflow.delta;
  delta?.map((item:any) => {
    if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
      connData.push({
        type: "BLOB",
        id: item.connectionId,
      });
    }
  });

  let publish = devWorkflow.publish;
    publish?.map((item:any) => {
      if(item.type != "SQL")
      {
        if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
          connData.push({ type: item.type, id: item.connectionId });
        }
        if (connData.findIndex((data) => data.id == item.blobConnectionId) == -1) {
          connData.push({ type: "BLOB", id: item.blobConnectionId });
        }
      }
      else{
        if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
          connData.push({ type: "BLOB",id: item.connectionId });
        }
      }
    });

    let connectionItemsUatFinal = {} as ConnectionsCollection

    Object.keys(devConnections).forEach((key: string) => {

      let connectionItemsDev = devConnections[key];
      let connectionItemsUat = uatConnections[key];
     
      connData.map((connDataItem) => {

        if(connectionItemsDev && connDataItem.id.length != 0 && connDataItem.type.length != 0)
        {
          if(connDataItem.type.toUpperCase() == "ADLS" || connDataItem.type.toUpperCase() == "ADLSGEN1")
        {
          const devData = connectionItemsDev.adlsConnections.find((data:any)=> data.connectionId == connDataItem?.id);
          const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.adlsConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

            if(uatIndex > -1 && devData)
            {
                let updatedAdlsConn = [...connectionItemsUat.adlsConnections];
                updatedAdlsConn[uatIndex] = devData;
                connectionItemsUat = {...connectionItemsUat, adlsConnections: updatedAdlsConn};
            }
            else if (devData)
            { 
              if(connectionItemsUat != undefined )
                {
                  const totalConnections = connectionItemsUat.adlsConnections.length;
                  let updatedAdlsConn = [...connectionItemsUat.adlsConnections];
                  updatedAdlsConn[totalConnections] = devData;
                  connectionItemsUat = {...connectionItemsUat, adlsConnections: updatedAdlsConn};
                }
            }
        }
      }
      if(connDataItem.type.toUpperCase() == "BLOB")
      {
        const devData = connectionItemsDev.blobConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.blobConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
            
              let updatedBlobConn = [...connectionItemsUat.blobConnections];
              updatedBlobConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, blobConnections: updatedBlobConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.blobConnections.length;
              let updatedBlobConn = [...connectionItemsUat.blobConnections];
              updatedBlobConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, blobConnections: updatedBlobConn};
            }
           
          }
      }


      if(connDataItem.type.toUpperCase() == "COSMOS")
      {
        const devData = connectionItemsDev.cosmosConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined? connectionItemsUat.cosmosConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedCosmosConn = [...connectionItemsUat.cosmosConnections];
              updatedCosmosConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, cosmosConnections: updatedCosmosConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.cosmosConnections.length;
              let updatedCosmosConn = [...connectionItemsUat.cosmosConnections];
              updatedCosmosConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, cosmosConnections: updatedCosmosConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "API")
      {
        const devData = connectionItemsDev.apiConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.apiConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedApiConn = [...connectionItemsUat.apiConnections];
              updatedApiConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, apiConnections: updatedApiConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.apiConnections.length;
              let updatedApiConn = [...connectionItemsUat.apiConnections];
              updatedApiConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, apiConnections: updatedApiConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "SQL")
      {
        const devData = connectionItemsDev.sqlConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.sqlConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedSqlConn = [...connectionItemsUat.sqlConnections];
              updatedSqlConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlConnections: updatedSqlConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.sqlConnections.length;
              let updatedSqlConn = [...connectionItemsUat.sqlConnections];
              updatedSqlConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlConnections: updatedSqlConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "SQLAAD")
      {
        const devData = connectionItemsDev.sqlaadConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.sqlaadConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedSqlaadConn = [...connectionItemsUat.sqlaadConnections];
              updatedSqlaadConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlaadConnections: updatedSqlaadConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.sqlaadConnections.length;
              let updatedSqlaadConn = [...connectionItemsUat.sqlaadConnections];
              updatedSqlaadConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlaadConnections: updatedSqlaadConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "TOPIC")
      {
        const devData = connectionItemsDev.topicConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.topicConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedTopicConn = [...connectionItemsUat.topicConnections];
              updatedTopicConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, topicConnections: updatedTopicConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined )
            {
              const totalConnections = connectionItemsUat.topicConnections.length;
              let updatedTopicConn = [...connectionItemsUat.topicConnections];
              updatedTopicConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, topicConnections: updatedTopicConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "EVENT")
      {
        const devData = connectionItemsDev.eventConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.eventConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedEventConn = [...connectionItemsUat.eventConnections];
              updatedEventConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, eventConnections: updatedEventConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined )
            {
              const totalConnections = connectionItemsUat.eventConnections.length;
              let updatedEventConn = [...connectionItemsUat.eventConnections];
              updatedEventConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, eventConnections: updatedEventConn};
            }
          }
      }

      connectionItemsUatFinal = connectionItemsUat;

      });
   });
   return connectionItemsUatFinal;

};

const DatasetReleaseActionsPRODC: React.FC<any> = (props: any) => {
  
  const userId = useSelector((state: RootState) => state.userDetails.localAccountId);
  const dispatch = useDispatch();
  const dispatchApp = useDispatch<AppDispatch>();
  const uatConnections = useSelector((state: RootState) => state.releaseData.uatConnections );
  const prodConnections = useSelector((state: RootState) => state.releaseData.prodConnections );
  const userSalesRoles = useSelector((state: RootState) => state.userSalesRoles);
  const uatWorkflow = props.uatWorkflow;
  const actionedVersion = props.selectedVersion;
  const subscriptionKey = props.subscriptionKey;
  const workflowId = props.workflowId;
  const releaseId = props.releaseId;
  const selectedReleaseIds = props.selectedReleaseIds;
  const uatAppPersona = useSelector((state: RootState) => state.releaseData.uatAppPersonas) ;
  const [prodApproveReject, setprodApproveReject] = useState(true);
  const [prodDeploy, setprodDeploy] = useState(true);
  const releaseRows = props.releaseRows;
  const [showErrorNotif, setShowErrorNotif] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [successText, setSuccessText] = useState("");
  const [showSuccessNotif, setShowSuccessNotif] = useState(false);
  const workflowName = props.workflowName;

  const releasePermProd = useSelector(prodReleasePermissionsSelector).release;
  const approvePermProd = useSelector(prodReleasePermissionsSelector).approve;
  const superAdmin = useSelector((state: RootState) => state.isSuperAdmin.isSuperAdmin);

  useEffect(() => {

    const uatStatus = releaseRows.find((x:any) => x.cells.field1 == actionedVersion)?.cells.field3;
    const prodStatus = releaseRows.find((x:any) => x.cells.field1 == actionedVersion)?.cells.field4;
    const prodApprove = releaseRows.find((x:any) => x.id == actionedVersion)?.cells.field4;
    
    setprodDeploy(actionedVersion ? (uatStatus == "Deployed" && (prodStatus == "Draft" || prodStatus == "") ? false : true) : true);
    setprodApproveReject(prodApprove == "Awaiting Approval" ? false : true);

  }, [actionedVersion, releaseRows]);

  return (
    <div 
    style={{display:"flex", border:"none", outline:"none", boxShadow:"none", padding:"4px", fontSize:"14px", alignItems:"center", marginRight:"12px", marginLeft:"12px"}}>

      <div> <SuccessNotification successNotif={showSuccessNotif} setsuccesnotif={setShowSuccessNotif} successText = {successText} /> </div>
      <div> <ErrorNotification errorNotif={showErrorNotif} seterrornotif={setShowErrorNotif} errorText = {errorText} /> </div>

      <div>
      <span style={{fontWeight:"700", marginRight:"8px"}}>PROD</span>
      </div>

      <div>
      <CommandBar>
      <Button appearance="command" disabled={prodDeploy || selectedReleaseIds.length != 1}
      onClick={ async() =>
        {
          if (releasePermProd.includes(subscriptionKey) || superAdmin || userSalesRoles.isSpaUser || userSalesRoles.isSpaAdmin) {

          const updatedWorkflow = {...uatWorkflow, status:"Submitted", environment: "prod" };
          dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));
          
          const propagateRelease = handlePostRelease({workflowId: workflowId , version : actionedVersion , releaseId : releaseId });
          const updatedPropagateRelease = {...propagateRelease, status:"Submitted", environment: "prod" }
          dispatchApp(postReleaseReleaseManagement({payload: updatedPropagateRelease, env:"prod"}));
          dispatch(addRelease({input: updatedPropagateRelease, env:"prod"}));
          dispatch(setReleaseStatus({version: actionedVersion, status: "Submitted", env: "prod"}));

          const propagateConnections =  handlePropagateConnections( {devWorkflow : props.uatWorkflow, devConnections : uatConnections, uatConnections: prodConnections} )
          if(propagateConnections)
          {
            dispatchApp(propagateConnectionReleaseManagement({payload:propagateConnections, env:"prod", subscriptionKey: subscriptionKey}));
            dispatch(addConnection({subskey: subscriptionKey, input: propagateConnections, env:"prod"}));
          }
          
            setprodDeploy(true);
            setShowSuccessNotif(true); setSuccessText("Submitted for Approval");          
          }
          else
          {
            setErrorText("You do not have permission to deploy this workflow"); setShowErrorNotif(true);
          }
        }
      }>
        <Icon slot="start" name="rocket"></Icon>
        Deploy
      </Button>
      <Button appearance="command" 
      disabled = {prodApproveReject || selectedReleaseIds.length != 1} 
      onClick= { async() => 
       { 
        if(approvePermProd.includes(subscriptionKey) || superAdmin || userSalesRoles.isSpaUser || userSalesRoles.isSpaAdmin)
        { 
            const hasApprovedList = [];
            hasApprovedList.push(userId);
            const updatedWorkflow = {...uatWorkflow, hasApproved:hasApprovedList, environment: "prod", schedule: {} as Schedule };
            dispatch(patchReleaseWorkflow({input: updatedWorkflow, env: "prod"}));
    
            dispatch(setWorkflowSummaryStatus({workflowId: workflowId, status: "Published"}));
            dispatch(setReleaseWorkflowStatus({status: "Published", env:"prod"}));
    
            dispatch(setReleaseStatus({version: actionedVersion, status: "Published", env: "prod"}));
            const propagateRelease = handlePostRelease({workflowId: workflowId , version : actionedVersion , releaseId : releaseId });
            dispatchApp(postReleaseReleaseManagement({payload: propagateRelease, env:"prod"}));
            
            await dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));                   
          
            await dispatchApp(publishWorkflowReleaseManagement({workflowId: workflowId , env:"prod"})).then(unwrapResult).then((result)=>{ 
            if(result == true)
            {
              setShowSuccessNotif(true); setSuccessText("PROD Deployment completed")
            }
            else
            {
              setErrorText("PROD deployment failed, Invalid workflow"); setShowErrorNotif(true);
              const updatedWorkflow = {...uatWorkflow, status:"New", environment: "prod" };
              dispatch(patchReleaseWorkflow({input: updatedWorkflow, env: "prod"}));
              dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));

              dispatch(setWorkflowSummaryStatus({workflowId: workflowId, status: "New"}));
              dispatch(setReleaseWorkflowStatus({status: "New", env:"prod"}));

              dispatch(setReleaseStatus({version: actionedVersion, status: "New", env: "prod"}));
            } 
          }); 
          setprodApproveReject(true);
        }
        else
        {
          setErrorText("You do not have permission to approve this workflow"); setShowErrorNotif(true);
        }}
         }>
        <Icon slot="start" name="accept"></Icon>
        Approve
      </Button>
      <Button appearance="command" disabled = {prodApproveReject || selectedReleaseIds.length != 1} 
      onClick={() => {
         if(approvePermProd.includes(subscriptionKey) || superAdmin || userSalesRoles.isSpaUser || userSalesRoles.isSpaAdmin)
         {
          
          const updatedWorkflow = {...uatWorkflow, status:"New", environment: "prod" };
          dispatch(patchReleaseWorkflow({input: updatedWorkflow, env: "prod"}));
          dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));

          dispatch(setWorkflowSummaryStatus({workflowId: workflowId, status: "New"}));
          dispatch(setReleaseWorkflowStatus({status: "New", env:"prod"}));

          dispatch(setReleaseStatus({version: actionedVersion, status: "New", env: "prod"}));
          
          setShowSuccessNotif(true); setSuccessText("Workflow Rejected");
          setprodDeploy(false);
         }
         else
         {
           setErrorText("You do not have permission to reject in PROD");  setShowErrorNotif(true);
         }
      }}>
        <Icon slot="start" name="calculatormultiply"></Icon>
        Reject
      </Button>

      
    </CommandBar>
      </div>
    </div>

  );
};
export const DatasetReleaseActionsPROD = withErrorBoundary("Release Actions Prod", DatasetReleaseActionsPRODC);